import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { initialPeriodsTableRow, IPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.MARKETING_AND_SALES}.${BUSINESS_TOOL_SUB_SECTIONS.MARKETING_AND_SALES.SALES_PLAN}` as const;

export const CHANNELS_NAMES = {
  NAME: 'name',
  SHARE: 'share',
  DESCRIPTION: 'description',
} as const;

export interface IChannels {
  [CHANNELS_NAMES.NAME]: string;
  [CHANNELS_NAMES.SHARE]: string;
  [CHANNELS_NAMES.DESCRIPTION]: string;
}

export const channelsInitialValues = {
  [CHANNELS_NAMES.NAME]: '',
  [CHANNELS_NAMES.SHARE]: '',
  [CHANNELS_NAMES.DESCRIPTION]: '',
};

export const STAGES_NAMES = {
  STAGE: 'stage',
  DESCRIPTION: 'description',
} as const;

export interface ISalesStages {
  [STAGES_NAMES.STAGE]: string;
  [STAGES_NAMES.DESCRIPTION]: string;
}

export const salesStagesInitialValues = {
  [STAGES_NAMES.STAGE]: '',
  [STAGES_NAMES.DESCRIPTION]: '',
};

export const SALES_NAMES = {
  CURRENCY: 'currency',
  GOALS: 'goals',
  STAGES: 'stages',
  AFFECT_FACTORS: 'affectFactors',
  PERFORMANCE_INDICATORS: 'performanceIndictors',
  PLANNED_PRODUCTS_VOLUME: 'plannedProductsVolume',
  PLANNED_PRODUCTS_VOLUME_TOTAL: 'totalPlannedProductsVolume',
  CHANNELS: 'salesChannels',
  DETAILED_SALES_CHANNEL: 'detailedSalesChannel',
  SALES_TEAM_STRUCTURE: 'salesTeamStructure',
  MOTIVATION_SYSTEM: 'motivationSystem',
} as const;

export interface ISales {
  [SALES_NAMES.GOALS]: string;
  [SALES_NAMES.STAGES]: ISalesStages[];
  [SALES_NAMES.AFFECT_FACTORS]: string;
  [SALES_NAMES.PERFORMANCE_INDICATORS]: string;
  [SALES_NAMES.PLANNED_PRODUCTS_VOLUME]?: IPeriodsTableRow[];
  [SALES_NAMES.PLANNED_PRODUCTS_VOLUME_TOTAL]?: IPeriodsTableRow;
  [SALES_NAMES.CHANNELS]: IChannels[];
  [SALES_NAMES.DETAILED_SALES_CHANNEL]: string;
  [SALES_NAMES.SALES_TEAM_STRUCTURE]: string;
  [SALES_NAMES.MOTIVATION_SYSTEM]: string;
}

export const salesInitialValues = {
  [SALES_NAMES.GOALS]: '',
  [SALES_NAMES.STAGES]: [salesStagesInitialValues],
  [SALES_NAMES.AFFECT_FACTORS]: '',
  [SALES_NAMES.PERFORMANCE_INDICATORS]: '',
  [SALES_NAMES.PLANNED_PRODUCTS_VOLUME]: [],
  [SALES_NAMES.PLANNED_PRODUCTS_VOLUME_TOTAL]: initialPeriodsTableRow,
  [SALES_NAMES.CHANNELS]: [channelsInitialValues],
  [SALES_NAMES.DETAILED_SALES_CHANNEL]: '',
  [SALES_NAMES.SALES_TEAM_STRUCTURE]: '',
  [SALES_NAMES.MOTIVATION_SYSTEM]: '',
};
